import React from 'react';

const ContextButtonContext = React.createContext({});
export default ContextButtonContext;
